import { render, staticRenderFns } from "./GinIndex.vue?vue&type=template&id=c0d2081a&scoped=true"
import script from "./GinIndex.vue?vue&type=script&lang=js"
export * from "./GinIndex.vue?vue&type=script&lang=js"
import style0 from "./GinIndex.vue?vue&type=style&index=0&id=c0d2081a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d2081a",
  null
  
)

export default component.exports